<template>
    <div id="nurse-booking" class="pt-2">
        <div class="main-nursebooking" v-if="startSection == false">
            <div v-if="!overviewModule" class="">
                <div class="top-links">
                    <!-- <router-link to="/">
                        <span><i class="fas fa-arrow-left"></i> Back</span>
                    </router-link> -->
                    <div class="logo text-center d-sm-none d-block">
                        <router-link to="/">
                            <img src="/img/logo_selcare_512.png" class="home-logo" alt="" loading="lazy">
                        </router-link>
                    </div>
                </div>
                <div class="d-none d-sm-none d-md-block">
                    <div class="row">
                        <div class="col-md-3 p-0">
                            <div class="img-top" @click="overviewModule = 'confinement'">
                                <img src="/img/confinement_008.jpg" alt="">
                                <div class="info-text">
                                    <span>More Info</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 p-0">
                            <div class="img-top" @click="overviewModule = 'nursing'">
                                <img src="/img/childcare_010.jpg" alt="">
                                <div class="info-text">
                                    <span>More Info</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 p-0">
                            <div class="img-top" @click="overviewModule = 'physio'">
                                <img src="/img/physio_012.jpg" alt="">
                                <div class="info-text">
                                    <span>More Info</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 p-0">
                            <div class="img-top" @click="overviewModule = 'caregiver'">
                                <img src="/img/elderly_017.jpg" alt="">
                                <div class="info-text">
                                    <span>More Info</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container" style="padding: 30px 25px">
                    <div class="row">
                        <div class="col-md-6 col-sm-12">
                            <div class="">
                                <div class="main-heading">
                                    <h2>About Us</h2>
                                </div>
                                <div class="main-description">
                                    <p class="text-justify">
                                        Established in 2021, SELCARE Nursing is responsible to provide excellent, safe and
                                        comprehensive nursing care and healthcare services that meet client requirements in a 
                                        professional and caring manner.
                                    </p>
                                    <p class="text-justify">
                                        We strive to offer home care services in nursing, midwifery, physiotherapy, general care, 
                                        and other disciplines for patients of all ages.
                                    </p>
                                </div>
                                <div class="main-heading mt-4">
                                    <h2>Our Vision</h2>
                                </div>
                                <div class="main-description">
                                    <p class="text-justify">
                                        To be the preferred nursing care service provider in the country.
                                    </p>
                                </div>
                                <div class="main-heading mt-4">
                                    <h2>Our Mission</h2>
                                </div>
                                <div class="main-description">
                                    <p class="text-justify">
                                        To deliver safe and comprehensive nursing care for patients and community.
                                    </p>
                                </div>
                                <!-- <div class="pt-3">
                                    <div class="main-package mt-4">
                                        <div class="card-deck mb-3 text-center">
                                            <div class="row no-gutters">
                                                <div class="col-4">
                                                    <div class="card mb-4 box-shadow" @click="downloadPoster(1)">
                                                        <div class="card-body">
                                                            <div class="overlay-text">
                                                                <span>Download</span>
                                                            </div>
                                                            <img src="/img/confinement_1.jpg" width="100%" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="card mb-4 box-shadow" @click="downloadPoster(2)">
                                                        <div class="card-body">
                                                            <div class="overlay-text">
                                                                <span>Download</span>
                                                            </div>
                                                            <img src="/img/confinement_2.jpg" width="100%" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="card mb-4 box-shadow" @click="downloadPoster(3)">
                                                        <div class="card-body">
                                                            <div class="overlay-text">
                                                                <span>Download</span>
                                                            </div>
                                                            <img src="/img/confinement_3.jpg" width="100%" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="main-description">
                                    <p class="text-justify">
                                        <i>Quick Tip: Want to check out our brochures? Simply click on any of 
                                            the three images above to get started!</i>
                                    </p>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12 d-md-block d-sm-none d-none">
                            <div class="">
                                <img class="d-block w-100" src="/img/nurses_003.jpg" />
                                <img class="d-block w-100" src="/img/homenursing_banner_2.jpg" />
                            </div>
                            <!-- <div class="main-banner shadow">
                                <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <img class="d-block w-100" src="/img/homenursing_banner_1.jpg" alt="First slide">
                                        </div>
                                        <div class="carousel-item">
                                            <img class="d-block w-100" src="/img/homenursing_banner_2.jpg" alt="First slide">
                                        </div>
                                    </div>
                                    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="d-block d-sm-block d-md-none d-lg-none d-xl-none mb-4">
                    <div class="row">
                        <div class="col-6 p-0">
                            <div class="img-top" @click="overviewModule = 'confinement'">
                                <img src="/img/confinement_008.jpg" alt="">
                                <div class="info-text">
                                    <span>More Info</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 p-0">
                            <div class="img-top" @click="overviewModule = 'nursing'">
                                <img src="/img/childcare_010.jpg" alt="">
                                <div class="info-text">
                                    <span>More Info</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 p-0">
                            <div class="img-top" @click="overviewModule = 'physio'">
                                <img src="/img/physio_012.jpg" alt="">
                                <div class="info-text">
                                    <span>More Info</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 p-0">
                            <div class="img-top" @click="overviewModule = 'caregiver'">
                                <img src="/img/elderly_017.jpg" alt="">
                                <div class="info-text">
                                    <span>More Info</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container pt-2 text-center">
                    <button v-if="currentCustomer" class="btn btn-primary btn-get-started" @click="startSection = true">Book Your Appointment Now</button>
                    <button v-else class="btn btn-primary btn-get-started" @click="$router.push('/auth/login')">Book Your Appointment Now</button>
                </div>
            </div>
            <div v-else class="pt-4 pt-sm-4 pt-md-0 pt-lg-0">
                <div class="top-links mb-4 mt-4">
                    <!-- <router-link to="/">
                        <span><i class="fas fa-arrow-left"></i> Back</span>
                    </router-link> -->
                    <div class="logo text-center d-sm-none d-block">
                        <router-link to="/">
                            <img src="/img/logo_selcare_512.png" class="home-logo" alt="" loading="lazy">
                        </router-link>
                    </div>
                </div>
                <div v-if="overviewModule == 'confinement'">
                    <div class="row d-block d-sm-block d-md-flex d-lg-flex d-xl-flex">
                        <div class="col-md-8 col-12">
                            <div class="image-side">
                                <div class="overlay-gradient"></div>
                                <img src="/img/confinement_008.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-md-4 col-12">
                            <div class="text-aside">
                                <h2>Confinement</h2>
                                <div class="pt-3">
                                    <div class="main-package mt-4">
                                        <div class="card-deck mb-3 text-center">
                                            <div class="row no-gutters">
                                                <div class="col-4">
                                                    <div class="card mb-4 box-shadow" @click="downloadPoster(1)">
                                                        <div class="card-body">
                                                            <div class="overlay-text">
                                                                <span>Download</span>
                                                            </div>
                                                            <img src="/img/confinement_1.jpg" width="100%" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="card mb-4 box-shadow" @click="downloadPoster(2)">
                                                        <div class="card-body">
                                                            <div class="overlay-text">
                                                                <span>Download</span>
                                                            </div>
                                                            <img src="/img/confinement_2.jpg" width="100%" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4">
                                                    <div class="card mb-4 box-shadow" @click="downloadPoster(3)">
                                                        <div class="card-body">
                                                            <div class="overlay-text">
                                                                <span>Download</span>
                                                            </div>
                                                            <img src="/img/confinement_3.jpg" width="100%" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="main-description">
                                    <p class="text-justify">
                                        <i>Quick Tip: Want to check out our brochures? Simply click on any of 
                                            the three images above to get started!</i>
                                    </p>
                                </div>
                                <div class="mt-3 d-flex flex-column align-items-center">
                                    <button v-if="currentCustomer" class="btn btn-primary btn-get-started" @click="() => { startSection = true; overviewModule = null; category = 'confinement'; section = '2' }">Book Now</button>
                                    <button v-else class="btn btn-primary btn-get-started" @click="$router.push('/auth/login')">Book Now</button>
                                    <span class="mt-2 small-back-text" @click="overviewModule = null;">Back to Main</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overview-about">
                        <h2>ABOUT US</h2>
                        <div class="">
                            <p>Selcare Nursing provides postnatal care and support to new mothers during the recovery period after childbirth. 
                                These services typically include assistance with baby care, meal preparation, massage, and other specialized 
                                treatments to promote the mother's well-being and recovery.</p>
                        </div>
                    </div>
                </div>
                <div v-if="overviewModule == 'nursing'">
                    <div class="row">
                        <div class="col-md-8 col-12">
                            <div class="image-side">
                                <div class="overlay-gradient"></div>
                                <img src="/img/childcare_010.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-md-4 col-12">
                            <div class="text-aside">
                                <h2>Nursing Care</h2>
                                <div class="mt-3 d-flex flex-column align-items-center">
                                    <button v-if="currentCustomer" class="btn btn-primary btn-get-started" @click="() => { startSection = true; overviewModule = null; category = 'nurse'; section = '2' }">Book Now</button>
                                    <button v-else class="btn btn-primary btn-get-started" @click="$router.push('/auth/login')">Book Now</button>
                                    <span class="mt-2 small-back-text" @click="overviewModule = null;">Back to Main</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overview-about">
                        <h2>ABOUT US</h2>
                        <div class="">
                            <p>Discover heartfelt healthcare with our Nursing Care services. Our dedicated nurses, driven by compassion, deliver personalised and attentive healthcare. 
                                From health monitoring to medication administration and assistance with daily needs, our services extend beyond the confines of hospitals to the comfort 
                                of homes. At Selcare Nursing, our focus is on ensuring the well-being of individuals through warm, friendly, and personalised nursing care.</p>
                        </div>
                    </div>
                </div>
                <div v-if="overviewModule == 'physio'">
                    <div class="row">
                        <div class="col-md-8 col-12">
                            <div class="image-side">
                                <div class="overlay-gradient"></div>
                                <img src="/img/physio_012.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-md-4 col-12">
                            <div class="text-aside">
                                <h2>Physiotherapy Service</h2>
                                <div class="mt-3 d-flex flex-column align-items-center">
                                    <button v-if="currentCustomer" class="btn btn-primary btn-get-started" @click="() => { startSection = true; overviewModule = null; category = 'physio'; section = '2' }">Book Now</button>
                                    <button v-else class="btn btn-primary btn-get-started" @click="$router.push('/auth/login')">Book Now</button>
                                    <span class="mt-2 small-back-text" @click="overviewModule = null;">Back to Main</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overview-about">
                        <h2>ABOUT US</h2>
                        <div class="">
                            <p>Embark on a journey to wellness with Selcare Nursing's warm and friendly Physiotherapy services. Our healthcare professionals are dedicated to assisting 
                                individuals in rediscovering and maintaining movement and function. With a gentle touch and expert quidance, our skilled physiotherapists utilise a 
                                range of techniques, exercises, and manual therapies. Addressing injuries, disabilities, or conditions affecting muscles, joints, and the nervous system, 
                                our primary goal is to enhance mobility, alleviate pain, and uplift overall quality of life.</p>
                        </div>
                    </div>
                </div>
                <div v-if="overviewModule == 'caregiver'">
                    <div class="row">
                        <div class="col-md-8 col-12">
                            <div class="image-side">
                                <div class="overlay-gradient"></div>
                                <img src="/img/elderly_017.jpg" alt="">
                            </div>
                        </div>
                        <div class="col-md-4 col-12">
                            <div class="text-aside">
                                <h2>General Care / Caregiver</h2>
                                <div class="mt-3 d-flex flex-column align-items-center">
                                    <button v-if="currentCustomer" class="btn btn-primary btn-get-started" @click="() => { startSection = true; overviewModule = null; category = 'care_aide'; section = '2' }">Book Now</button>
                                    <button v-else class="btn btn-primary btn-get-started" @click="$router.push('/auth/login')">Book Now</button>
                                    <span class="mt-2 small-back-text" @click="overviewModule = null;">Back to Main</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overview-about">
                        <h2>ABOUT US</h2>
                        <div class="">
                            <p>At Selcare Nursing, we extend a compassionate hand through our General Care and Caregiver services. Tailored to meet the unique needs of each individual 
                                facing challenges in self-care due to illness, disability, or aging, our services encompass personal care, meal preparation, transportation, household tasks, 
                                companionship, and medical care. Whether provided by family members, friends, or our team of professional caregivers, our commitment is to create a warm and 
                                supportive environment in various settings.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="section == 1">
                <div class="container pt-2">
                    <div class="top-links">
                        <!-- <router-link to="/">
                            <span><i class="fas fa-arrow-left"></i> Back</span>
                        </router-link> -->
                        <div class="logo text-center d-sm-none d-block mb-4">
                            <router-link to="/">
                                <img src="/img/logo_selcare_512.png" class="home-logo" alt="" loading="lazy">
                            </router-link>
                        </div>
                    </div>
                    <div class="card main-card">
                        <div class="card-title">
                            <img src="/img/card_1.png" alt="">
                            <span>Booking for Home Nursing / Physio</span>
                        </div>
                        <div class="card-body mt-2">
                            <p>
                                SELCARE Nursing strives to offer home care services in nursing, midwifery,
                                physiotherapy, general care and other disciplines for patients of all ages. Whatsapp us at 
                                <u><span id="phonewa" @click="phonePress()" style="cursor:pointer;">019&shy;6661767</span></u> 
                                or online self-booking below.
                            </p>
                            <!-- <p>
                                SELCARE Nursing strives to offer home care services in nursing, midwifery,
                                physiotherapy, general care and other disciplines for patients of all ages. The services
                                that we provide is a cost efficient way to deliver quality care in the convenience of the
                                patient’s home.
                            </p> -->
                            <!-- <p>
                                These services are intended for patients that require skilled nursing personnel to assess,
                                initiate and oversee nursing interventions. SELCARE will create care plans to achieve goals
                                based on the patient’s diagnosis i.e. preventive, therapeutic, and rehabilitative actions.
                            </p> -->

                            <div v-if="!currentCustomer && !newCustomer" class="mt-5" style="height:400px">
                                <div class="row">
                                    <div class="col-sm-6 col-12 offset-sm-3">
                                        <div class="text-center">
                                            <h5>Are you an existing customer?</h5>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-6">
                                                <div class="card card-two text-center" @click="loginPress()">
                                                    <!-- <router-link to="/auth/login?redirect=booking"> -->
                                                        <div class="mb-2">
                                                            <svg width="39" height="45" viewBox="0 0 39 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path opacity="0.4" d="M30.6429 11.25C30.6429 13.475 29.9894 15.6501 28.765 17.5002C27.5406 19.3502 25.8003 20.7922 23.7642 21.6436C21.7281 22.4951 19.4877 22.7179 17.3262 22.2838C15.1647 21.8498 13.1792 20.7783 11.6208 19.205C10.0625 17.6316 9.00124 15.6271 8.57129 13.4448C8.14134 11.2625 8.36201 9.00048 9.20538 6.94481C10.0488 4.88914 11.477 3.13213 13.3094 1.89597C15.1418 0.659801 17.2962 0 19.5 0C22.4553 0 25.2895 1.18526 27.3792 3.29505C29.4689 5.40483 30.6429 8.26631 30.6429 11.25Z" fill="#A91A18"/>
                                                                <path d="M27.3 25.3125H25.8462C23.8563 26.2388 21.6912 26.7185 19.5 26.7185C17.3088 26.7185 15.1437 26.2388 13.1538 25.3125H11.7C8.59718 25.3132 5.62164 26.558 3.42762 28.7731C1.23359 30.9882 0.000692362 33.9923 0 37.125L0 40.7812C0 41.9001 0.440241 42.9732 1.22388 43.7644C2.00751 44.5555 3.07035 45 4.17857 45H34.8214C35.9297 45 36.9925 44.5555 37.7761 43.7644C38.5598 42.9732 39 41.9001 39 40.7812V37.125C38.9993 33.9923 37.7664 30.9882 35.5724 28.7731C33.3784 26.558 30.4028 25.3132 27.3 25.3125Z" fill="#A91A18"/>
                                                            </svg>
                                                        </div>
                                                        Login
                                                    <!-- </router-link> -->
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="card card-two text-center">
                                                    <div @click="newCustomer = true">
                                                        <div class="mb-2">
                                                            <svg width="58" height="46" viewBox="0 0 58 46" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <g clip-path="url(#clip0)">
                                                                    <path opacity="0.4"
                                                                        d="M58 20.125V23C58 23.3812 57.8472 23.7469 57.5753 24.0165C57.3033 24.2861 56.9345 24.4375 56.55 24.4375H50.75V30.1875C50.75 30.5687 50.5972 30.9344 50.3253 31.204C50.0533 31.4736 49.6845 31.625 49.3 31.625H46.4C46.0154 31.625 45.6466 31.4736 45.3746 31.204C45.1027 30.9344 44.95 30.5687 44.95 30.1875V24.4375H39.15C38.7654 24.4375 38.3966 24.2861 38.1246 24.0165C37.8527 23.7469 37.7 23.3812 37.7 23V20.125C37.7 19.7438 37.8527 19.3781 38.1246 19.1085C38.3966 18.839 38.7654 18.6875 39.15 18.6875H44.95V12.9375C44.95 12.5563 45.1027 12.1906 45.3746 11.921C45.6466 11.6515 46.0154 11.5 46.4 11.5H49.3C49.6845 11.5 50.0533 11.6515 50.3253 11.921C50.5972 12.1906 50.75 12.5563 50.75 12.9375V18.6875H56.55C56.9345 18.6875 57.3033 18.839 57.5753 19.1085C57.8472 19.3781 58 19.7438 58 20.125Z"
                                                                        fill="#7CC6D6" />
                                                                    <path
                                                                        d="M20.3 23C22.5943 23 24.837 22.3255 26.7446 21.0619C28.6522 19.7983 30.139 18.0022 31.017 15.9009C31.895 13.7995 32.1247 11.4872 31.6771 9.25647C31.2295 7.02569 30.1247 4.97658 28.5024 3.36828C26.8801 1.75997 24.8132 0.664704 22.563 0.220974C20.3129 -0.222756 17.9805 0.00498273 15.8609 0.875391C13.7412 1.7458 11.9296 3.21978 10.655 5.11095C9.38033 7.00211 8.7 9.22552 8.7 11.5C8.7 14.55 9.92214 17.4751 12.0976 19.6317C14.273 21.7884 17.2235 23 20.3 23ZM28.42 25.875H26.9066C24.8351 26.822 22.5811 27.3125 20.3 27.3125C18.0189 27.3125 15.7649 26.822 13.6934 25.875H12.18C8.94988 25.8757 5.85227 27.1481 3.56824 29.4125C1.2842 31.6768 0.000720767 34.7477 0 37.95L0 41.6875C0 42.8313 0.458302 43.9282 1.27409 44.7369C2.08987 45.5457 3.19631 46 4.35 46H36.25C37.4037 46 38.5101 45.5457 39.3259 44.7369C40.1417 43.9282 40.6 42.8313 40.6 41.6875V37.95C40.5993 34.7477 39.3158 31.6768 37.0318 29.4125C34.7477 27.1481 31.6501 25.8757 28.42 25.875Z"
                                                                        fill="#7CC6D6" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0">
                                                                        <rect width="58" height="46" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                        </div>
                                                        New
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="nursebooking-provider-link" class="bottom-right">
                                    <router-link to="/store/home-nursing/apply" class="text-muted">
                                        Provider Registration Click Here
                                    </router-link>
                                </div>
                            </div>
                            <div v-else class="row mt-5">
                                <div class="col-sm-6 col-12 offset-sm-3">
                                    <div class="text-center">
                                        <h5>Choose Category</h5>
                                    </div>
                                    <div class="cards mt-3">
                                        <div class="card normal-border">
                                            <label class="custom-radiocheck">
                                                <svg width="21" height="25" viewBox="0 0 21 25" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.4"
                                                        d="M19.0405 13.2812C19.0405 13.4885 18.9615 13.6872 18.8209 13.8337C18.6802 13.9802 18.4895 14.0625 18.2905 14.0625H14.4309C13.3757 15.0234 12.0112 15.625 10.4999 15.625C8.98867 15.625 7.62414 15.0234 6.56898 14.0625H2.70836C2.58048 14.0623 2.45477 14.0281 2.34316 13.9631C2.23154 13.8981 2.13775 13.8044 2.07067 13.691C2.0036 13.5776 1.96548 13.4482 1.95993 13.3151C1.95439 13.1821 1.9816 13.0497 2.03899 12.9307C2.75289 11.4746 3.50524 9.89209 4.0157 8.26562C4.02227 8.24463 4.02789 8.22412 4.03445 8.20312H6.74992V9.375C6.74992 10.411 7.14501 11.4046 7.84827 12.1371C8.55153 12.8697 9.50536 13.2812 10.4999 13.2812C11.4945 13.2812 12.4483 12.8697 13.1516 12.1371C13.8548 11.4046 14.2499 10.411 14.2499 9.375V8.20312H16.9687C16.9752 8.22412 16.9809 8.24463 16.9874 8.26562C17.497 9.89209 18.2493 11.4731 18.9632 12.9307C19.015 13.0396 19.0415 13.1597 19.0405 13.2812Z"
                                                        fill="#A91A18" />
                                                    <path
                                                        d="M14.9723 15.625L10.5 20.2827L6.02766 15.625C2.67656 15.7764 0 18.6328 0 22.1577C0 22.9115 0.287476 23.6345 0.799187 24.1675C1.3109 24.7005 2.00493 25 2.72859 25H18.2714C18.9951 25 19.6891 24.7005 20.2008 24.1675C20.7125 23.6345 21 22.9115 21 22.1577C21 18.6328 18.3234 15.7764 14.9723 15.625ZM16.5 4.74609V2.34375L10.5 0L4.5 2.34375V4.74609C4.50235 5.37991 4.46068 6.01307 4.37531 6.64062H16.6252C16.5394 6.01311 16.4976 5.37993 16.5 4.74609ZM12.375 4.31299C12.375 4.37774 12.3503 4.43984 12.3064 4.48562C12.2624 4.53141 12.2028 4.55713 12.1406 4.55713H11.1248V5.61523C11.1248 5.67998 11.1002 5.74208 11.0562 5.78787C11.0122 5.83365 10.9526 5.85938 10.8905 5.85938H10.1095C10.0474 5.85938 9.98776 5.83365 9.9438 5.78787C9.89985 5.74208 9.87516 5.67998 9.87516 5.61523V4.55713H8.85938C8.79721 4.55713 8.7376 4.53141 8.69365 4.48562C8.64969 4.43984 8.625 4.37774 8.625 4.31299V3.49951C8.625 3.43476 8.64969 3.37266 8.69365 3.32688C8.7376 3.28109 8.79721 3.25537 8.85938 3.25537H9.87516V2.19727C9.87516 2.13252 9.89985 2.07042 9.9438 2.02463C9.98776 1.97885 10.0474 1.95312 10.1095 1.95312H10.8905C10.9526 1.95312 11.0122 1.97885 11.0562 2.02463C11.1002 2.07042 11.1248 2.13252 11.1248 2.19727V3.25537H12.1406C12.2028 3.25537 12.2624 3.28109 12.3064 3.32688C12.3503 3.37266 12.375 3.43476 12.375 3.49951V4.31299Z"
                                                        fill="#A91A18" />
                                                </svg>
                                                Nurse
                                                <input type="radio" name="radio" v-model="category" value="nurse">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div class="card normal-border mt-2">
                                            <label class="custom-radiocheck">
                                                <svg width="21" height="25" viewBox="0 0 21 25" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.4"
                                                        d="M19.0405 13.2812C19.0405 13.4885 18.9615 13.6872 18.8209 13.8337C18.6802 13.9802 18.4895 14.0625 18.2905 14.0625H14.4309C13.3757 15.0234 12.0112 15.625 10.4999 15.625C8.98867 15.625 7.62414 15.0234 6.56898 14.0625H2.70836C2.58048 14.0623 2.45477 14.0281 2.34316 13.9631C2.23154 13.8981 2.13775 13.8044 2.07067 13.691C2.0036 13.5776 1.96548 13.4482 1.95993 13.3151C1.95439 13.1821 1.9816 13.0497 2.03899 12.9307C2.75289 11.4746 3.50524 9.89209 4.0157 8.26562C4.02227 8.24463 4.02789 8.22412 4.03445 8.20312H6.74992V9.375C6.74992 10.411 7.14501 11.4046 7.84827 12.1371C8.55153 12.8697 9.50536 13.2812 10.4999 13.2812C11.4945 13.2812 12.4483 12.8697 13.1516 12.1371C13.8548 11.4046 14.2499 10.411 14.2499 9.375V8.20312H16.9687C16.9752 8.22412 16.9809 8.24463 16.9874 8.26562C17.497 9.89209 18.2493 11.4731 18.9632 12.9307C19.015 13.0396 19.0415 13.1597 19.0405 13.2812Z"
                                                        fill="#A91A18" />
                                                    <path
                                                        d="M14.9723 15.625L10.5 20.2827L6.02766 15.625C2.67656 15.7764 0 18.6328 0 22.1577C0 22.9115 0.287476 23.6345 0.799187 24.1675C1.3109 24.7005 2.00493 25 2.72859 25H18.2714C18.9951 25 19.6891 24.7005 20.2008 24.1675C20.7125 23.6345 21 22.9115 21 22.1577C21 18.6328 18.3234 15.7764 14.9723 15.625ZM16.5 4.74609V2.34375L10.5 0L4.5 2.34375V4.74609C4.50235 5.37991 4.46068 6.01307 4.37531 6.64062H16.6252C16.5394 6.01311 16.4976 5.37993 16.5 4.74609ZM12.375 4.31299C12.375 4.37774 12.3503 4.43984 12.3064 4.48562C12.2624 4.53141 12.2028 4.55713 12.1406 4.55713H11.1248V5.61523C11.1248 5.67998 11.1002 5.74208 11.0562 5.78787C11.0122 5.83365 10.9526 5.85938 10.8905 5.85938H10.1095C10.0474 5.85938 9.98776 5.83365 9.9438 5.78787C9.89985 5.74208 9.87516 5.67998 9.87516 5.61523V4.55713H8.85938C8.79721 4.55713 8.7376 4.53141 8.69365 4.48562C8.64969 4.43984 8.625 4.37774 8.625 4.31299V3.49951C8.625 3.43476 8.64969 3.37266 8.69365 3.32688C8.7376 3.28109 8.79721 3.25537 8.85938 3.25537H9.87516V2.19727C9.87516 2.13252 9.89985 2.07042 9.9438 2.02463C9.98776 1.97885 10.0474 1.95312 10.1095 1.95312H10.8905C10.9526 1.95312 11.0122 1.97885 11.0562 2.02463C11.1002 2.07042 11.1248 2.13252 11.1248 2.19727V3.25537H12.1406C12.2028 3.25537 12.2624 3.28109 12.3064 3.32688C12.3503 3.37266 12.375 3.43476 12.375 3.49951V4.31299Z"
                                                        fill="#A91A18" />
                                                </svg>
                                                Physio
                                                <input type="radio" name="radio" v-model="category" value="physio">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div class="card normal-border mt-2">
                                            <label class="custom-radiocheck">
                                                <svg width="21" height="26" viewBox="0 0 21 26" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.4"
                                                        d="M16.5 6.5C16.5 5.21442 16.1481 3.95772 15.4888 2.8888C14.8295 1.81988 13.8925 0.986756 12.7961 0.494786C11.6998 0.00281633 10.4934 -0.125905 9.32947 0.124899C8.16558 0.375703 7.09648 0.994768 6.25737 1.90381C5.41825 2.81285 4.84681 3.97104 4.6153 5.23192C4.38378 6.49279 4.5026 7.79973 4.95673 8.98744C5.41086 10.1752 6.17989 11.1903 7.16659 11.9046C8.15328 12.6188 9.31332 13 10.5 13C12.0913 13 13.6174 12.3152 14.7427 11.0962C15.8679 9.87721 16.5 8.22391 16.5 6.5ZM6.75001 18.8195V14.625H6.30001C5.94818 14.6251 5.59698 14.6569 5.25001 14.72V18.8195C4.64576 19.0147 4.12654 19.439 3.78731 20.0148C3.44807 20.5905 3.31148 21.2794 3.40251 21.9553C3.49354 22.6312 3.8061 23.2491 4.28306 23.6958C4.76001 24.1426 5.36948 24.3885 6.00001 24.3885C6.63054 24.3885 7.24001 24.1426 7.71696 23.6958C8.19391 23.2491 8.50648 22.6312 8.59751 21.9553C8.68854 21.2794 8.55195 20.5905 8.21271 20.0148C7.87347 19.439 7.35426 19.0147 6.75001 18.8195ZM6.00001 22.75C5.7775 22.75 5.56 22.6785 5.37499 22.5446C5.18999 22.4107 5.04579 22.2203 4.96064 21.9976C4.87549 21.775 4.85322 21.5299 4.89662 21.2935C4.94003 21.0571 5.04718 20.8399 5.20451 20.6695C5.36185 20.499 5.5623 20.3829 5.78053 20.3359C5.99876 20.2889 6.22496 20.313 6.43053 20.4053C6.63609 20.4975 6.81179 20.6537 6.93541 20.8542C7.05903 21.0546 7.12501 21.2902 7.12501 21.5313C7.12538 21.6914 7.09653 21.8501 7.04013 21.9981C6.98372 22.1462 6.90087 22.2807 6.79633 22.3939C6.69179 22.5072 6.56762 22.5969 6.43097 22.6581C6.29431 22.7192 6.14785 22.7504 6.00001 22.75ZM14.9906 18.4031V14.6326C14.8941 14.6275 14.7975 14.625 14.7 14.625H13.9172C13.7803 14.6927 13.6413 14.7569 13.5 14.8175V18.393C12.1781 18.7738 11.25 20.1449 11.25 21.6734V23.1563C11.2507 23.3715 11.3299 23.5778 11.4703 23.7301L11.9531 24.2531C12.0234 24.3291 12.1187 24.3718 12.218 24.3718C12.3173 24.3718 12.4125 24.3291 12.4828 24.2531L13.0125 23.6793C13.0826 23.6031 13.122 23.5 13.122 23.3924C13.122 23.2848 13.0826 23.1816 13.0125 23.1055L12.7453 22.816V21.5313C12.746 21.2948 12.7942 21.0613 12.8864 20.847C12.9787 20.6326 13.1128 20.4426 13.2796 20.29C13.4463 20.1374 13.6417 20.0258 13.8521 19.9631C14.0626 19.9003 14.2831 19.8879 14.4984 19.9266C15.2344 20.0586 15.7453 20.8102 15.7453 21.6176V22.816L15.4781 23.1055C15.408 23.1816 15.3686 23.2848 15.3686 23.3924C15.3686 23.5 15.408 23.6031 15.4781 23.6793L16.0078 24.2531C16.0781 24.3291 16.1734 24.3718 16.2727 24.3718C16.372 24.3718 16.4672 24.3291 16.5375 24.2531L17.0203 23.7301C17.1608 23.5778 17.24 23.3715 17.2406 23.1563V21.5313C17.2384 20.8135 17.0163 20.1169 16.609 19.5507C16.2018 18.9845 15.6325 18.5809 14.9906 18.4031Z"
                                                        fill="#A91A18" />
                                                    <path
                                                        d="M14.9906 14.6326V18.4031C15.6325 18.5809 16.2018 18.9845 16.609 19.5507C17.0163 20.1169 17.2384 20.8135 17.2406 21.5312V23.1562C17.24 23.3715 17.1608 23.5778 17.0203 23.7301L16.5375 24.2531C16.4672 24.3291 16.372 24.3718 16.2727 24.3718C16.1734 24.3718 16.0781 24.3291 16.0078 24.2531L15.4781 23.6793C15.408 23.6031 15.3686 23.5 15.3686 23.3924C15.3686 23.2848 15.408 23.1816 15.4781 23.1055L15.7453 22.816V21.6176C15.7453 20.8102 15.2344 20.0586 14.4984 19.9266C14.2831 19.8879 14.0626 19.9003 13.8521 19.9631C13.6416 20.0258 13.4463 20.1374 13.2795 20.29C13.1128 20.4426 12.9787 20.6326 12.8864 20.847C12.7942 21.0613 12.746 21.2948 12.7453 21.5312V22.816L13.0125 23.1055C13.0826 23.1816 13.122 23.2848 13.122 23.3924C13.122 23.5 13.0826 23.6031 13.0125 23.6793L12.4828 24.2531C12.4125 24.3291 12.3173 24.3718 12.218 24.3718C12.1187 24.3718 12.0234 24.3291 11.9531 24.2531L11.4703 23.7301C11.3298 23.5778 11.2506 23.3715 11.25 23.1562V21.6734C11.25 20.1449 12.1781 18.7738 13.5 18.393V14.8175C12.474 15.2573 11.3762 15.467 10.2732 15.434C9.17017 15.4009 8.08481 15.1257 7.08281 14.625H6.75V18.8195C7.35425 19.0147 7.87346 19.439 8.2127 20.0147C8.55194 20.5905 8.68853 21.2794 8.5975 21.9553C8.50647 22.6312 8.1939 23.249 7.71695 23.6958C7.24 24.1426 6.63053 24.3885 6 24.3885C5.36947 24.3885 4.76 24.1426 4.28305 23.6958C3.8061 23.249 3.49353 22.6312 3.4025 21.9553C3.31147 21.2794 3.44806 20.5905 3.7873 20.0147C4.12654 19.439 4.64575 19.0147 5.25 18.8195V14.72C3.78221 14.9895 2.44984 15.8131 1.48892 17.0449C0.527999 18.2767 0.000546203 19.8372 0 21.45L0 23.5625C0 24.209 0.237053 24.829 0.65901 25.2861C1.08097 25.7432 1.65326 26 2.25 26H18.75C19.3467 26 19.919 25.7432 20.341 25.2861C20.7629 24.829 21 24.209 21 23.5625V21.45C20.9995 19.6946 20.3748 18.0069 19.2557 16.7374C18.1367 15.4679 16.6092 14.7141 14.9906 14.6326ZM4.875 21.5312C4.875 21.7723 4.94098 22.0079 5.0646 22.2083C5.18821 22.4088 5.36391 22.565 5.56948 22.6572C5.77505 22.7495 6.00125 22.7736 6.21948 22.7266C6.43771 22.6796 6.63816 22.5635 6.7955 22.393C6.95283 22.2226 7.05998 22.0054 7.10338 21.769C7.14679 21.5326 7.12451 21.2876 7.03936 21.0649C6.95422 20.8422 6.81002 20.6518 6.62502 20.5179C6.44001 20.384 6.2225 20.3125 6 20.3125C5.85216 20.3121 5.7057 20.3433 5.56904 20.4045C5.43238 20.4656 5.30822 20.5553 5.20368 20.6686C5.09914 20.7818 5.01628 20.9163 4.95988 21.0644C4.90347 21.2124 4.87463 21.3711 4.875 21.5312Z"
                                                        fill="#A91A18" />
                                                </svg>
                                                Medical Assistant
                                                <input type="radio" name="radio" v-model="category" value="medical_assistant">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div class="card normal-border mt-2">
                                            <label class="custom-radiocheck">
                                                <svg width="26" height="21" viewBox="0 0 26 21" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.4"
                                                        d="M18.8502 14.4375C18.2074 14.4375 17.579 14.63 17.0446 14.9905C16.5101 15.3511 16.0935 15.8635 15.8476 16.4631C15.6016 17.0627 15.5372 17.7224 15.6626 18.3589C15.788 18.9954 16.0975 19.5801 16.5521 20.039C17.0066 20.4979 17.5857 20.8104 18.2161 20.937C18.8466 21.0636 19.5 20.9986 20.0939 20.7502C20.6877 20.5019 21.1953 20.0813 21.5524 19.5417C21.9096 19.0021 22.1002 18.3677 22.1002 17.7188C22.1002 16.8485 21.7578 16.0139 21.1483 15.3986C20.5388 14.7832 19.7121 14.4375 18.8502 14.4375ZM7.15015 14.4375C6.50736 14.4375 5.87901 14.63 5.34455 14.9905C4.81009 15.3511 4.39352 15.8635 4.14754 16.4631C3.90155 17.0627 3.83719 17.7224 3.9626 18.3589C4.088 18.9954 4.39753 19.5801 4.85205 20.039C5.30657 20.4979 5.88567 20.8104 6.51611 20.937C7.14655 21.0636 7.80001 20.9986 8.39387 20.7502C8.98773 20.5019 9.49532 20.0813 9.85243 19.5417C10.2095 19.0021 10.4002 18.3677 10.4002 17.7188C10.4002 16.8485 10.0577 16.0139 9.44825 15.3986C8.83876 14.7832 8.01211 14.4375 7.15015 14.4375ZM12.0252 5.25H9.75015V2.95313C9.75015 2.8661 9.71591 2.78264 9.65496 2.72111C9.59402 2.65957 9.51135 2.625 9.42515 2.625H7.47515C7.38896 2.625 7.30629 2.65957 7.24534 2.72111C7.18439 2.78264 7.15015 2.8661 7.15015 2.95313V5.25H4.87515C4.78895 5.25 4.70629 5.28457 4.64534 5.34611C4.58439 5.40764 4.55015 5.4911 4.55015 5.57813V7.54688C4.55015 7.6339 4.58439 7.71736 4.64534 7.7789C4.70629 7.84044 4.78895 7.87501 4.87515 7.87501H7.15015V10.1719C7.15015 10.2589 7.18439 10.3424 7.24534 10.4039C7.30629 10.4654 7.38896 10.5 7.47515 10.5H9.42515C9.51135 10.5 9.59402 10.4654 9.65496 10.4039C9.71591 10.3424 9.75015 10.2589 9.75015 10.1719V7.87501H12.0252C12.1114 7.87501 12.194 7.84044 12.255 7.7789C12.3159 7.71736 12.3502 7.6339 12.3502 7.54688V5.57813C12.3502 5.4911 12.3159 5.40764 12.255 5.34611C12.194 5.28457 12.1114 5.25 12.0252 5.25Z"
                                                        fill="#A91A18" />
                                                    <path
                                                        d="M25.35 14.4375H24.7V10.0037C24.6991 9.48191 24.4931 8.9818 24.1272 8.61328L20.0687 4.51582C19.7037 4.1464 19.2084 3.93839 18.6916 3.9375H16.9V1.96875C16.9 1.44661 16.6946 0.945846 16.3289 0.576634C15.9632 0.207421 15.4672 0 14.95 0L1.95 0C1.43283 0 0.936838 0.207421 0.571142 0.576634C0.205446 0.945846 0 1.44661 0 1.96875L0 15.0938C0 15.6159 0.205446 16.1167 0.571142 16.4859C0.936838 16.8551 1.43283 17.0625 1.95 17.0625H2.68775C3.00625 14.8448 4.86606 13.125 7.15 13.125C9.43394 13.125 11.3157 14.8419 11.6342 17.0625H14.3658C14.6847 14.8419 16.5636 13.125 18.85 13.125C21.1364 13.125 22.9937 14.8448 23.3123 17.0625H25.35C25.5224 17.0625 25.6877 16.9934 25.8096 16.8703C25.9315 16.7472 26 16.5803 26 16.4062V15.0938C26 14.9197 25.9315 14.7528 25.8096 14.6297C25.6877 14.5066 25.5224 14.4375 25.35 14.4375ZM12.35 7.54688C12.35 7.6339 12.3158 7.71736 12.2548 7.77889C12.1939 7.84043 12.1112 7.875 12.025 7.875H9.75V10.1719C9.75 10.2589 9.71576 10.3424 9.65481 10.4039C9.59386 10.4654 9.5112 10.5 9.425 10.5H7.475C7.3888 10.5 7.30614 10.4654 7.24519 10.4039C7.18424 10.3424 7.15 10.2589 7.15 10.1719V7.875H4.875C4.7888 7.875 4.70614 7.84043 4.64519 7.77889C4.58424 7.71736 4.55 7.6339 4.55 7.54688V5.57812C4.55 5.4911 4.58424 5.40764 4.64519 5.34611C4.70614 5.28457 4.7888 5.25 4.875 5.25H7.15V2.95312C7.15 2.8661 7.18424 2.78264 7.24519 2.72111C7.30614 2.65957 7.3888 2.625 7.475 2.625H9.425C9.5112 2.625 9.59386 2.65957 9.65481 2.72111C9.71576 2.78264 9.75 2.8661 9.75 2.95312V5.25H12.025C12.1112 5.25 12.1939 5.28457 12.2548 5.34611C12.3158 5.40764 12.35 5.4911 12.35 5.57812V7.54688ZM22.75 10.5H16.9V5.90625H18.6916L22.75 10.0037V10.5Z"
                                                        fill="#A91A18" />
                                                </svg>
                                                Care Aide
                                                <input type="radio" name="radio" v-model="category" value="care_aide">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div class="card normal-border mt-2">
                                            <label class="custom-radiocheck">
                                                <svg width="21" height="25" viewBox="0 0 21 25" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.4"
                                                        d="M19.0405 13.2812C19.0405 13.4885 18.9615 13.6872 18.8209 13.8337C18.6802 13.9802 18.4895 14.0625 18.2905 14.0625H14.4309C13.3757 15.0234 12.0112 15.625 10.4999 15.625C8.98867 15.625 7.62414 15.0234 6.56898 14.0625H2.70836C2.58048 14.0623 2.45477 14.0281 2.34316 13.9631C2.23154 13.8981 2.13775 13.8044 2.07067 13.691C2.0036 13.5776 1.96548 13.4482 1.95993 13.3151C1.95439 13.1821 1.9816 13.0497 2.03899 12.9307C2.75289 11.4746 3.50524 9.89209 4.0157 8.26562C4.02227 8.24463 4.02789 8.22412 4.03445 8.20312H6.74992V9.375C6.74992 10.411 7.14501 11.4046 7.84827 12.1371C8.55153 12.8697 9.50536 13.2812 10.4999 13.2812C11.4945 13.2812 12.4483 12.8697 13.1516 12.1371C13.8548 11.4046 14.2499 10.411 14.2499 9.375V8.20312H16.9687C16.9752 8.22412 16.9809 8.24463 16.9874 8.26562C17.497 9.89209 18.2493 11.4731 18.9632 12.9307C19.015 13.0396 19.0415 13.1597 19.0405 13.2812Z"
                                                        fill="#A91A18" />
                                                    <path
                                                        d="M14.9723 15.625L10.5 20.2827L6.02766 15.625C2.67656 15.7764 0 18.6328 0 22.1577C0 22.9115 0.287476 23.6345 0.799187 24.1675C1.3109 24.7005 2.00493 25 2.72859 25H18.2714C18.9951 25 19.6891 24.7005 20.2008 24.1675C20.7125 23.6345 21 22.9115 21 22.1577C21 18.6328 18.3234 15.7764 14.9723 15.625ZM16.5 4.74609V2.34375L10.5 0L4.5 2.34375V4.74609C4.50235 5.37991 4.46068 6.01307 4.37531 6.64062H16.6252C16.5394 6.01311 16.4976 5.37993 16.5 4.74609ZM12.375 4.31299C12.375 4.37774 12.3503 4.43984 12.3064 4.48562C12.2624 4.53141 12.2028 4.55713 12.1406 4.55713H11.1248V5.61523C11.1248 5.67998 11.1002 5.74208 11.0562 5.78787C11.0122 5.83365 10.9526 5.85938 10.8905 5.85938H10.1095C10.0474 5.85938 9.98776 5.83365 9.9438 5.78787C9.89985 5.74208 9.87516 5.67998 9.87516 5.61523V4.55713H8.85938C8.79721 4.55713 8.7376 4.53141 8.69365 4.48562C8.64969 4.43984 8.625 4.37774 8.625 4.31299V3.49951C8.625 3.43476 8.64969 3.37266 8.69365 3.32688C8.7376 3.28109 8.79721 3.25537 8.85938 3.25537H9.87516V2.19727C9.87516 2.13252 9.89985 2.07042 9.9438 2.02463C9.98776 1.97885 10.0474 1.95312 10.1095 1.95312H10.8905C10.9526 1.95312 11.0122 1.97885 11.0562 2.02463C11.1002 2.07042 11.1248 2.13252 11.1248 2.19727V3.25537H12.1406C12.2028 3.25537 12.2624 3.28109 12.3064 3.32688C12.3503 3.37266 12.375 3.43476 12.375 3.49951V4.31299Z"
                                                        fill="#A91A18" />
                                                </svg>
                                                Confinement
                                                <input type="radio" name="radio" v-model="category" value="confinement">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="mt-5 mb-5 text-center">
                                        <button class="btn btn-secondary" @click="section = 2">Start Booking</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="section == 2">
                <div class="top-links mb-4">
                    <div class="logo ml-2 text-center d-sm-none d-block mb-4">
                        <router-link to="/">
                            <img src="/img/logo_selcare_512.png" class="home-logo" alt="" loading="lazy">
                        </router-link>
                    </div>
                </div>
                <details-comp 
                    @go-to="updateSection" 
                    @detailsSection-data="updateDetailsSectionData"
                    :category="categoryName"
                    :is_someone_else="is_someone_else"
                    :booker_info="booker_info"
                    :patient_info="patient_info"
                />
            </div>
            <div v-if="section == 3">
                <div class="top-links mb-4">
                    <div class="logo ml-2 text-center d-sm-none d-block mb-4">
                        <router-link to="/">
                            <img src="/img/logo_selcare_512.png" class="home-logo" alt="" loading="lazy">
                        </router-link>
                    </div>
                </div>
                <assessment-comp 
                @go-to="updateSection" 
                @assessmentSection-data="updateAssessmentSectionData"
                :category="categoryName"
                :listFixedPackagePrice="listFixedPackagePrice"
                :bookingServices="bookingServices" 
                :bookingAdditionalTreatments="bookingAdditionalTreatments" 
                :bookingAssessments="bookingAssessments" 
                :confinementServices="confinementServices"
                :confinementAddons="confinementAddons"
                :type_of_services="type_of_services"
                :additional_treatments="additional_treatments"
                :selected_confinement_services="selected_confinement_services"
                :selected_confinement_addons="selected_confinement_addons"
                :gender_requirement="gender_requirement"
                :language_requirement="language_requirement"
                :race_requirement="race_requirement"
                :assessments="assesments"
                :schedule_mode="schedule_mode"
                :schedule_date_only="category == 'confinement' ? true : false"
            />
            </div>
            <div v-if="section == 4">
                <div class="top-links mb-4">
                    <div class="logo ml-2 text-center d-sm-none d-block mb-4">
                        <router-link to="/">
                            <img src="/img/logo_selcare_512.png" class="home-logo" alt="" loading="lazy">
                        </router-link>
                    </div>
                </div>
                <summary-comp 
                    @go-to="updateSection" 
                    @submit-all-data="submitAllData"
                    :category="categoryName"
                    :invoice="invoiceSubmission"
                    :hasDeposited="hasDeposited"
                    :depositAmount="depositAmount"
                    :paymentOption="paymentOption"
                    :scheduleMode="schedule_mode"
                    :isConfirmed="bookingIsConfirmed"
                />
            </div>
            <div v-if="section == 5">
                <div class="top-links mb-4">
                    <div class="logo ml-2 text-center d-sm-none d-block mb-4">
                        <router-link to="/">
                            <img src="/img/logo_selcare_512.png" class="home-logo" alt="" loading="lazy">
                        </router-link>
                    </div>
                </div>
                <validation-error-comp 
                    :category="categoryName"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DetailsComp from '../../../components/nurse-booking/Details'
import AssessmentComp from '../../../components/nurse-booking/Assessment'
import SummaryComp from '../../../components/nurse-booking/Summary'
import ValidationErrorComp from '../../../components/nurse-booking/ValidationError'
import moment from 'moment'

import { mapGetters, mapActions } from 'vuex'

// import MobileDataClass from './../../utils/classes/MobileDataClass'
import API from './../../../utils/API'
export default {
    components: {
        DetailsComp,
        AssessmentComp,
        SummaryComp,
        ValidationErrorComp
    },
    data(){
        return {
            // currentView : 'home-nursing',
            // section: 3,
            startSection: false,
            overviewModule: null, //confinement, nursing, physio, caregiver
            section: 1,
            bookingServices: null,
            bookingAdditionalTreatments: null,
            confinementServices: null,
            confinementAddons: null,
            bookingAssessments: null,
            bookingIsConfirmed:false,
            newCustomer: false,
            isAssessmentChange: false,
            bookingSetting: null,
            listFixedPackagePrice: [],
            selectedFixedPackagePrice: null,

            /** Booking Submission Data */
            // category: 'confinement',
            // categoryName: 'Confinement',
            category: 'nurse',
            categoryName: 'Nurse',
            //get data from Details Component
            is_someone_else: false,
            booker_info: {
                user: null,
                name: null,
                gender: null,
                id_card_type: null,
                id_card_number: null,
                id_card_front_file: null,
                id_card_back_file: null,
                religion: null,
                race: null,
                phone: null,
                alt_phone: null,
                email: null
            },
            patient_info: {
                name: null,
                gender: null,
                id_card_type: null,
                id_card_number: null,
                id_card_front_file: null,
                id_card_back_file: null,
                religion: null,
                race: null,
                phone: null,
                alt_phone: null,
                email: null,
                address: {
                    lastname: null,
                    city: null,
                    zipcode: null,
                    phone: null,
                    province: null,
                    country: null,
                    firstname: null,
                    company: null,
                    address1: null,
                    address2: null,
                    location_name: null
                },
                relationship: null,
                weight: null,
                height: null,
                patient_diagnosis: null,
                has_allergies: null,
                allergies: null,
                has_past_surgical_history: null,
                past_surgical_history: null,
                has_past_medical_history: null,
                past_medical_history: null,
            },
            //get data from Assessment Component
            type_of_services: [],
            additional_treatments: [],
            selected_confinement_services: [],
            selected_confinement_addons: [],
            medical_supplies: [],
            assesments: [],
            gender_requirement: null,
            language_requirement: null,
            race_requirement: null,
            schedule_start_datetime: undefined,
            schedule_end_datetime: undefined,
            schedule_mode: 'default',
            package_name: '',
            hasDeposited: false,
            depositAmount: 0.00,
            paymentOption: null, //full_payment or half_payment
            /** Booking Submission Data */
            /** Invoice Submission Data */
            invoiceSubmission: {}
            /** Invoice Submission Data */
        }
    },
    computed: {
        ...mapGetters(['currentCustomer']),
    },
    watch: {
        category(){
            //initiate selection for fixedPackagePrice
            let selectedServicePricing = this.bookingSetting.service_pricing.find(service => service.category_type == this.category)
            if(selectedServicePricing && selectedServicePricing.price_rate_type == 'fixed') this.listFixedPackagePrice = selectedServicePricing.fixed_price_rates
            else this.listFixedPackagePrice = []

            //reinit booking related items
            if(selectedServicePricing)
                this.initBookingItems()
            if(this.category == 'confinement')
                this.initConfinementItems()

            switch (this.category) {
                case 'nurse':
                    return this.categoryName = 'Nurse'
                case 'physio':
                    return this.categoryName = 'Physio'
                case 'medical_assistant':
                    return this.categoryName = 'Medical Assistant'
                case 'care_aide':
                    return this.categoryName = 'Care Aide'
                case 'confinement':
                    return this.categoryName = 'Confinement'

                default:
                    break;
            }
        }
    },
    methods: {
        ...mapActions(['createInvoicePayment']),
        ...mapActions(['signup']),
        // callJSCurrentView(){
        //     return this.currentView
        // },
        loginPress(){
            if (window.ReactNativeWebView) {
                // window.webkit.messageHandlers.sendData.postMessage("home");
                window.ReactNativeWebView.postMessage('LOGIN')
            } else {
                this.$router.push({ path: '/auth', params: { redirect: 'booking' } })
            }
        },
        phonePress(){
            if (window.ReactNativeWebView) {
                // window.webkit.messageHandlers.sendData.postMessage("home");
                window.ReactNativeWebView.postMessage('PHONE')
            } else {
                window.open('https://wa.me/+60196661767')
            }
        },
        async initBookingItems(){
            //load all service related items for Assessment section filtered by category (only 1 cat)
            let resBookingCat = await API.get(`/booking-categories?attr_name=${this.category}`)
            // let res01 = await API.get('/booking-services?booking_categories=${bookingCat.id}')
            // let res02 = await API.get('/booking-additional-treatments?booking_categories=${bookingCat.id}')
            // let res03 = await API.get('/booking-assessments?booking_categories=${bookingCat.id}')
            // this.bookingServices = res01.data
            this.bookingServices = resBookingCat.data[0].booking_services
            this.type_of_services = []
            this.bookingServices.forEach(item => {
                this.type_of_services.push({
                    is_tick: false,
                    service: item.id,
                    service_notes: null
                })
            })
            // this.bookingAdditionalTreatments = res02.data
            this.bookingAdditionalTreatments = resBookingCat.data[0].booking_additional_treatments
            this.additional_treatments = []
            this.bookingAdditionalTreatments.forEach(item => {
                this.additional_treatments.push({
                    is_tick: false,
                    treatment: item.id,
                    treatment_notes: null
                })
            })
            // this.bookingAssessments = res03.data
            this.bookingAssessments = resBookingCat.data[0].booking_assessments
            this.assesments = []
            this.bookingAssessments.forEach(item => {
                this.assesments.push({
                    is_tick: item.is_ticked_by_default? true : false,
                    assessment: item.id,
                    explaination: null
                })
            })
        },
        async initConfinementItems(){
            let res01 = await API.get('/confinement-services')
            let res02 = await API.get('/confinement-addons')
            this.confinementServices = res01.data
            this.confinementAddons = res02.data
        },
        updateDetailsSectionData(ev){
            this.is_someone_else = ev.is_someone_else
            this.booker_info = ev.booker_info
            this.patient_info = ev.patient_info
        },
        updateAssessmentSectionData(ev){
            this.gender_requirement = ev.gender_requirement
            this.language_requirement = ev.language_requirement
            this.race_requirement = ev.race_requirement
            this.schedule_mode = ev.schedule_mode
            this.schedule_start_datetime = ev.schedule_start_datetime
            this.schedule_end_datetime = ev.schedule_end_datetime
            this.medical_supplies = ev.medical_supplies,
            this.selectedFixedPackagePrice = ev.selectedFixedPackagePrice
            this.selected_confinement_services = ev.selected_confinement_services
            this.selected_confinement_addons = ev.selected_confinement_addons

            console.log('selected_confinement_services : ', this.selected_confinement_services)
            console.log('selected_confinement_addons : ', this.selected_confinement_addons)

            if(this.schedule_mode == 'custom')
                this.submitAllData(ev)
        },
        async updateSection(ev){
            //if at invoice section already
            if(ev == 4) await this.generateDraftInvoice()

            this.section = ev
            //scroll top
            window.scrollTo(0,0)
        },
        async generateDraftInvoice(){
            //set line_item for Services
            let selectedServiceItems = []
            let line_items = []
            let subtotal = 0.00
            let selectedServiceItemsTotal = 0.00

            if(this.category !== 'confinement'){
                //price based on category & times with hour
                this.type_of_services.forEach((item, ind) => {
                    if(item.is_tick == true){
                        selectedServiceItems.push({
                            name: this.bookingServices.find(_item => _item.id == item.service).service,
                            total: 0.00
                        })
                        selectedServiceItemsTotal += 0.00
                    }
                })

                //calculate the booking service total
                let serviceTotal = 0.00
                if(this.schedule_mode != 'custom'){
                    let servicePricing = this.bookingSetting.service_pricing.find(service => service.category_type == this.category)
                    if(servicePricing && servicePricing.price_rate_type == 'dynamic') { //for dynamic pricing
                        //for our frontend just cover 24 hours and below only
                        let diffHourTime = moment(this.schedule_end_datetime).diff(moment(this.schedule_start_datetime), 'hours')
                        let extraHours = diffHourTime - servicePricing.dynamic_price_rate.first_hours_value
                        if(extraHours <= 0) serviceTotal = diffHourTime * servicePricing.dynamic_price_rate.first_hours_price
                        else if(extraHours <= 12){ 
                            serviceTotal = (servicePricing.dynamic_price_rate.first_hours_value * servicePricing.dynamic_price_rate.first_hours_price) + (extraHours * servicePricing.dynamic_price_rate.extra_12_hours_price)
                            this.package_name = 'week_12_hours_price'
                        }
                        else if(extraHours <= 24){
                            serviceTotal = (servicePricing.dynamic_price_rate.first_hours_value * servicePricing.dynamic_price_rate.first_hours_price) + (extraHours * servicePricing.dynamic_price_rate.extra_24_hours_price)
                            this.package_name = 'week_24_hours_price'
                        }
                    }else if(servicePricing && servicePricing.price_rate_type == 'fixed'){
                        serviceTotal = this.selectedFixedPackagePrice.price
                        this.package_name = this.selectedFixedPackagePrice.name
                    }
                }
                
                line_items.push({
                    title: 'Required Services',
                    type: 'default',
                    items: selectedServiceItems,
                    is_hide_item_total: true,
                    total: serviceTotal
                })
                subtotal += serviceTotal

                //set line_item for Additional Treatment
                let selectedAdditionalTreatmentItems = []
                let selectedAdditionalTreatmentItemsTotal = 0.00
                this.additional_treatments.forEach((item, ind) => {
                    if(item.is_tick == true){
                        selectedAdditionalTreatmentItems.push({
                            name: this.bookingAdditionalTreatments.find(_item => _item.id == item.treatment).treatment,
                            total: this.bookingAdditionalTreatments[ind].price
                        })
                        selectedAdditionalTreatmentItemsTotal += this.bookingAdditionalTreatments[ind].price
                    }
                })

                line_items.push({
                    title: 'Additional Treatment (Price inclusive of medical supplies)',
                    type: 'default',
                    items: selectedAdditionalTreatmentItems,
                    total: selectedAdditionalTreatmentItemsTotal
                })
                subtotal += selectedAdditionalTreatmentItemsTotal
                
                //set line_item for Medical Supplies
                let selectedMedicalSuppliesItems = []
                let selectedMedicalSuppliesItemsTotal = 0.00
                this.medical_supplies.forEach((product, ind) => {
                    selectedMedicalSuppliesItems.push({
                        name: product.item.title,
                        total: parseFloat(product.item.variants[0].price * product.quantity)
                    })
                    selectedMedicalSuppliesItemsTotal += parseFloat(product.item.variants[0].price * product.quantity)
                })

                line_items.push({
                    title: 'Medical Supplies',
                    type: 'unit_quantity',
                    items: selectedMedicalSuppliesItems,
                    total: selectedMedicalSuppliesItemsTotal
                })
                subtotal += selectedMedicalSuppliesItemsTotal
            }
            else {
                //set line_item for Confinement Services
                let selectedConfinementServicesItems = []
                let selectedConfinementServicesItemsTotal = 0.00
                this.selected_confinement_services.forEach(item => {
                    selectedConfinementServicesItems.push({
                        name: item.package_name,
                        total: parseFloat(item.price)
                    })

                    selectedConfinementServicesItemsTotal += parseFloat(item.price)
                })

                line_items.push({
                    title: 'Confinement Services',
                    type: 'default',
                    items: selectedConfinementServicesItems,
                    // is_hide_item_total: true,
                    total: selectedConfinementServicesItemsTotal
                })
                subtotal += selectedConfinementServicesItemsTotal

                //set line_item for Confinement Addons
                let selectedConfinementAddonsItems = []
                let selectedConfinementAddonsItemsTotal = 0.00
                this.selected_confinement_addons.forEach(item => {
                    selectedConfinementAddonsItems.push({
                        name: item.package_name,
                        quantity: item.quantity ? item.quantity : null,
                        total: parseFloat(item.price * item.quantity)
                    })

                    selectedConfinementAddonsItemsTotal += parseFloat(item.price * item.quantity)
                })

                line_items.push({
                    title: 'Confinement Addons',
                    type: 'default',
                    items: selectedConfinementAddonsItems,
                    // is_hide_item_total: true,
                    total: selectedConfinementAddonsItemsTotal
                })
                subtotal += selectedConfinementAddonsItemsTotal
            }

            //get invoice count based on year
            let currentYear = moment().format('YYYY')
            let resInvoiceCount = await API.get(`/invoices/count?invoice_number_contains=${currentYear}`)

            //set invoiceSubmission
            this.invoiceSubmission = {
                invoice_number: `SNSB/HOMENURSING/BOOKING/${currentYear}/${resInvoiceCount.data + 1}`,
                booking_form: null,
                booking_start_datetime: this.schedule_start_datetime,
                booking_end_datetime: this.schedule_end_datetime,
                address_from: {
                    firstname: 'SELCARE NURSING SDN BHD',
                    lastname: '',
                    address1: 'No. 1-02 & 1-03, Level 1',
                    address2: 'Jalan Pembangunan 14/6, Section 14',
                    city: 'Shah Alam',
                    zipcode: '40000',
                    province: 'Selangor'
                },
                address_to: {
                    firstname: this.patient_info.name,
                    address1: this.patient_info.address.address1,
                    address2: this.patient_info.address.address2,
                    city: this.patient_info.address.city,
                    zipcode: this.patient_info.address.zipcode,
                    province: this.patient_info.address.prvince,
                    phone: this.patient_info.phone,
                    email: this.patient_info.email
                },
                line_items: line_items,
                subtotal: subtotal,
                processing_fee: 0.00,
                deposit_fee: 0.00,
                transportation_fee: 25.00,
                tax: 0.00,
                total: 0.00, 
                status: 'pending',
                // issued_by: null,
                // customer: null,
                // checkout: null
            }
            //calculate processing fee
            this.invoiceSubmission.processing_fee = this.invoiceSubmission.subtotal * 0.1
            //calculate deposit
            // let subtotal = this.invoiceSubmission.subtotal
            if(subtotal >= 0 && subtotal <= 200.99 ) this.invoiceSubmission.deposit_fee = 50.00
            else if(subtotal >= 201.00 && subtotal <= 500.99) this.invoiceSubmission.deposit_fee = 100.00
            else if(subtotal >= 501.00 && subtotal <= 1000.99) this.invoiceSubmission.deposit_fee = 150.00
            else if(subtotal >= 1001.00) this.invoiceSubmission.deposit_fee = 250.00
            // //calculate tax (6%)
            // this.invoiceSubmission.tax = this.invoiceSubmission.subtotal * 0.06
            //calculate overall total
            this.invoiceSubmission.total = this.invoiceSubmission.subtotal + this.invoiceSubmission.processing_fee + this.invoiceSubmission.deposit_fee + this.invoiceSubmission.transportation_fee + this.invoiceSubmission.tax
            
        },
        async uploadFile(_file){
            let formData = new FormData()
            formData.append('files', _file)
            let resFileUpload = await API.post('/upload', formData)
            // console.log('res : ', resFileUpload.data)
            return resFileUpload.data[0].id
        },
        isValidated(){
            if(this.category === 'confinement') //only for confinement sahaja
                return true

            //check if assessment is changes or not
            //soon copy this to vuex
            this.assesments.forEach((assessment, ind) => {
                if(assessment.is_tick != this.bookingAssessments[ind].is_ticked_by_default)
                    this.isAssessmentChange = true
            })

            //check if the validation data is valid or not
            if(!this.patient_info.patient_diagnosis || this.patient_info.patient_diagnosis.trim() == ''
                || this.isAssessmentChange || this.schedule_mode == 'custom')
                return false
            else return true
        },
        async checkCurrentCustomer(_email, _idCardNumber){
            if(!this.currentCustomer){
                await this.signup({
                    username: _email.substring(0, _email.lastIndexOf("@")),
                    email: _email,
                    password: _idCardNumber,
                    redirectto: 'noredirect'
                })
            }
        },
        async submitAllData(ev){
            this.hasDeposited = ev.hasDeposited
            this.depositAmount = ev.depositAmount

            this.bookingIsConfirmed = true

            //upload all files first and link it
            if(this.booker_info.id_card_front_file)
                this.booker_info.id_card_front_file = await this.uploadFile(this.booker_info.id_card_front_file)
            if(this.booker_info.id_card_back_file)
                this.booker_info.id_card_back_file = await this.uploadFile(this.booker_info.id_card_back_file)
            if(this.patient_info.id_card_front_file)
                this.patient_info.id_card_front_file = await this.uploadFile(this.patient_info.id_card_front_file)
            if(this.patient_info.id_card_back_file)
                this.patient_info.id_card_back_file = await this.uploadFile(this.patient_info.id_card_back_file)

            //check whether the currentcustomer
            if(!this.is_someone_else) await this.checkCurrentCustomer(this.patient_info.email, this.patient_info.id_card_number)
            else await this.checkCurrentCustomer(this.booker_info.email, this.booker_info.id_card_number)

            //remap data for confinements
            let confinementServices = []
            if(this.selected_confinement_services.length > 0) {
                confinementServices = this.selected_confinement_services.map(i => {
                    return {
                        confinement_service: i.id,
                        quantity: 0
                    }
                })
            }
            let confinementAddons = []
            if(this.selected_confinement_addons.length > 0) {
                confinementAddons = this.selected_confinement_addons.map(i => {
                    return {
                        confinement_addon: i.id,
                        quantity: i.quantity
                    }
                })
            }

            //create and submit new form data
            let data2send = {
                customer: this.currentCustomer? this.currentCustomer.user.customer.id : null,
                category: this.category,
                package_name: this.package_name,
                is_someone_else: this.is_someone_else,
                booker_info: this.booker_info,
                patient_info: this.patient_info,
                type_of_services: this.type_of_services,
                additional_treatments: this.additional_treatments,
                medical_supplies: this.medical_supplies,
                assesments: this.assesments,
                confinement_services: confinementServices,
                confinement_addons: confinementAddons,
                gender_requirement: this.gender_requirement,
                language_requirement: this.language_requirement,
                race_requirement: this.race_requirement,
                schedule_start_datetime: this.schedule_start_datetime,
                schedule_end_datetime: this.schedule_end_datetime,
                schedule_mode: this.schedule_mode,
                booking_mode: 'provider',
                booking_mode_status: 'ongoing',
                booking_status: 'pending',
                financial_status: 'pending',
                booking_number: this.currentCustomer? (moment().format('YYYYMMDDHHmm') + this.currentCustomer.user.customer.id.substring(0,5)).toUpperCase() : moment().format('YYYYMMDDHHmm'),
                has_deposited: this.hasDeposited,
                deposit_amount: this.depositAmount

            }

            //check if the validation data is valid or not
            if(!this.isValidated()){
                data2send.booking_status = 'validation_error'
            }

            API.post('/booking-forms', data2send)
                .then(bookingRes => {
                    //check if the validation data is valid or not
                    //right now just by patient diagnosis
                    if(!this.isValidated()){
                        return this.section = 5
                    }

                    // console.log('booking form : ', bookingRes.data)
                    // if all ok, then proceed to payment
                    this.invoiceSubmission.booking_form = bookingRes.data.id
                    API.post('/invoices', this.invoiceSubmission)
                        .then(invoiceRes => {
                            // window.location.href = `/home-nursing/booking/${bookingRes.data.id}/invoice/${invoiceRes.data.id}`
                            let payloadData = {
                                email: invoiceRes.data.address_to.email,
                                phone: invoiceRes.data.address_to.phone,
                                fullname: invoiceRes.data.address_to.firstname,
                                description: `Invoice payment at ${moment().format('dddd, D MMMM YYYY')}`,
                                testmode: true, // for now
                                total_price: this.hasDeposited ? this.depositAmount : invoiceRes.data.total,
                                total_tax: invoiceRes.data.tax,
                                invoice: invoiceRes.data,
                                transaction_type: 'invoice'
                            }
                            this.createInvoicePayment(payloadData)
                        })
                })
        },
        downloadPoster(_val){
            let href
            let filename
            switch (_val) {
                case 1:
                    href = '/data/pamplet_daily_traditional.pdf'
                    filename = 'CONFINEMENT SERVICES (DAILY VISIT).pdf'
                    break;
                case 2:
                    href = '/data/pamplet_stayin_traditional.pdf'
                    filename = 'CONFINEMENT SERVICES (STAYIN TRADITIONAL).pdf'
                    break;
                case 3:
                    href = '/data/pamplet_stayin_modern.pdf'
                    filename = 'CONFINEMENT SERVICES (STAYIN MODERN).pdf'
                    break;
            }

            var anchor = document.createElement('a');
            anchor.href = href;
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            
            return;
        }
    },
    async mounted(){
        //load booking setting items
        let bookingSettingRes = await API.get('/booking-setting')
        this.bookingSetting = bookingSettingRes.data

        //initiate selection for fixedPackagePrice
        let selectedServicePricing = this.bookingSetting.service_pricing.find(service => service.category_type == this.category)
        if(selectedServicePricing && selectedServicePricing.price_rate_type == 'fixed') this.listFixedPackagePrice = selectedServicePricing.fixed_price_rates

        if(selectedServicePricing)//init booking related items for assessments
            this.initBookingItems()
        if(this.category == 'confinement')
            this.initConfinementItems()

        //android/ios sendata function callback
        // let Android = new MobileDataClass()
        // Android.sendData('home-nursing')
        // window.callJSCurrentView = this.callJSCurrentView
        // console.log('current view : ', window.callJSCurrentView())

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sendData) {
            window.webkit.messageHandlers.sendData.postMessage("home-nursing");
        }
        try {
            if($Android){
                $Android.sendData("home-nursing")
            }

        } catch (err) {
            console.log('.. .')
        }
    }
}
</script>

<style scoped>
a {
    color: initial;
    text-decoration: unset;
}

p {
    font-size: 14px;
    margin-bottom: 10px;
}

.small-back-text {
    font-size: 11px;
    text-decoration: underline;
    color: #a91a17;
    cursor: pointer;
}

.img-top {
    width: 100%;
    height: 250px;
    position: relative;
    cursor: pointer;
}
.img-top img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.img-top .info-text {
    position: absolute;
    bottom: 25px;
    display: flex;
    width: 100%;
    justify-content: center;
}
.img-top .info-text span {
    color: #fff;
    background-color: #a91a17;
    border-radius: 17px;
    padding: 6px 35px;
    font-size: 14px;
}

.image-side {
    width: 100%;
    height: 550px;
    position: relative;
}
.image-side .overlay-gradient {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to right, #f2f3f7,#ffffff00,#ffffff00,#ffffff00,#ffffff00,#ffffff00,#f2f3f7);
}
.image-side img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.text-aside {
    display: flex;
    height: 550px;
    flex-direction: column;
    justify-content: center;
    padding: 10px 20px;
}
.text-aside h2, h3 {
    color: #a91a17;
    font-weight: 600;
    text-align: center;
}

.overview-about {
 padding: 35px 30px;
}
.overview-about h2 {
    color: #a91a17;
    font-weight: 700;
}
.overview-about p {
    text-align: justify;
}

.card.main-card {
    border: unset;
    padding: 15px;
    background-color: #ffffff;
}
.card.main-card .card-title {
    background-color: #E14DB8;
    height: 75px;
    border-radius: 10px;
    /* position: relative; */
}
.card.main-card .card-title img {
    height: 100%;
    margin-left: 10px;
}
.card.main-card .card-title span {
    margin-left: 20px;
    color: #ffffff;
    font-weight: 500;
}
.card.main-card .card-body {
    padding: 0px;
}
.card.main-card .card-body .bottom-right {
    position: absolute;
    bottom: 20px;
    left: 0px;
    width: 100%;
    text-align: center;
}
.card.normal-border {
    border-radius: 10px;
}
.card.card-two {
    padding: 30px;
    border-radius: 15px;
    border: 1px solid #EBEEF2;
    cursor: pointer;
}

/** Custom RadioCheck start */
/* The container */
.custom-radiocheck {
  display: block;
  position: relative;
  padding-left: 20px;
  margin: 15px 0px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.custom-radiocheck svg {
    margin-right: 15px;
}

/* Hide the browser's default radio button */
.custom-radiocheck input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 5px;
  right: 15px;
  height: 25px;
  width: 25px;
  /* background-color: #eee; */
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.custom-radiocheck:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.custom-radiocheck input:checked ~ .checkmark {
  background-color: #19AB4F;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.custom-radiocheck input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.custom-radiocheck .checkmark:after {
 	top: 7px;
	left: 10px;
	width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
/** Custom RadioCheck end */

.btn.btn-secondary {
    background-color: #7CC6D6;
    border-color: #7CC6D6;
    padding: 15px 40px;
    border-radius: 10px;
}


/* Main Nurse Booking Page */
.main-nursebooking {
    
}
.main-nursebooking .main-heading{
    font-weight: 600;
    text-transform: uppercase;
}
.main-nursebooking .main-heading h2,
.main-nursebooking .main-heading h3,
.main-nursebooking .main-heading h4{
    color: #a91a17;
    font-weight: bolder;
}
.main-nursebooking .main-description{
    text-align: center;
}
.main-nursebooking .main-description p{
    font-weight: 400;
}
.main-nursebooking .main-banner{
    border: 2px solid #afafaf30;
}
.main-nursebooking .main-package{
    
}
.main-nursebooking .main-package .card{
    transition: all 0.3s;
    border-radius: 50%;
    /* margin: unset;
    margin-right: 10px;
    margin-left: 10px; */
    position: relative;
}
.main-nursebooking .main-package .card:hover{
    transform: scale(1.05);
}
.main-nursebooking .main-package .card .card-body{
    padding: 0px;
    cursor: pointer;
}
.main-nursebooking .main-package .card .card-footer{
    color: #fff;
    /* background-image: linear-gradient(#d93734fa, #a91a17); */
    background-color: #a91a17;
    padding: 10px 10px;
    cursor: pointer;
}
.main-nursebooking .main-package .card img{
    border-radius: 50%;
}
.main-nursebooking .main-package .card .overlay-text{
    position: absolute;
    width: 100%;
    /* top: 45%; */
    opacity: 0;
    height: 100%;
    background: #ffffffba;
    border: 1px solid #a91a17;
    border-radius: 50%;
    padding-top: 40%;
}
.main-nursebooking .main-package .card .overlay-text:hover{
    opacity: 1;
    transition: .5s ease;
}
.main-nursebooking .main-package .card .overlay-text span{
    color: #a91a17;
    font-weight: 600;
}
.btn.btn-primary.btn-get-started {
    width: 50%;
    padding: 15px 10px;
    border-radius: 20px;
    background-color: #a91a17;
    border: unset;
}

@media (max-width: 575px) {
    .btn.btn-primary.btn-get-started {
        width: 100%;
    }
}
/* Main Nurse Booking Page */


/** Media Queries */
@media (max-width: 575px) {

    .top-links {
        margin-bottom: 20px;
    }
    .top-links > a {
        float: left;
        margin-top: 10px;
    }
    .top-links .logo {
        margin-right: 20px;
    }
    .top-links .home-logo {
        height: 75px;
    }
}
@media (max-width: 450px) {
    .card.main-card .card-title img {
        height: 70%;
        margin-left: 0px;
        margin-top: 21px;
    }
    .card.main-card .card-title span {
        font-size: 13px;
    }
    .image-side {
        height: 250px;
    }
    .text-aside {
        min-height: 200px;
        height: unset;
        padding: 30px 20px;
    }
}
</style>